<template>
  <vue-final-modal
    :value="store.visible"
    name="skill-diagnosis-popup"
    :classes="['skill-diagnosis-popup__container']"
    :content-class="[
      'skill-diagnosis-popup__shell',
      'v--modal-box',
      'v--modal'
    ]"
    :click-to-close="true"
    :esc-to-close="true"
    :lock-scroll="true"
    attach="body"
    @input="setVisible"
  >
    <div class="v--modal-close-top">
      <el-button
        @click="closePopup"
        icon="el-icon-circle-close"
        style="font-size: 2rem; padding: 0"
        type="text"
      />
    </div>
    <div class="setting">
      <SkillDiagnosisBody
        :state="state"
        :is-yagi-prime="isYagiPrime"
        :can-diagnose="canDiagnose"
        :has-resume-data="hasResumeData"
        :needs-job-history="needsJobHistory"
        :insufficient-message="insufficientMessage"
        :error-message="errorMessage"
        :zone-display-name="zoneDisplayName"
        :show-skip-option="showSkipOption"
        :hide-popup-for-10-days="hidePopupFor10Days"
        :result="result"
        @run="runDiagnosis"
        @reset="resetToReady"
        @pay="openPaymentDialog"
        @toggle-skip="hidePopupFor10Days = !hidePopupFor10Days"
      />
    </div>
  </vue-final-modal>
</template>

<script setup lang="ts">
/**
 * 隠れスキル診断 UI。開閉は Pinia `useSkillDiagnosisPopupStore`。
 */
import { computed, getCurrentInstance } from 'vue'
import SkillDiagnosisBody from '@/components/aptitude/SkillDiagnosisBody.vue'
import {
  useSkillDiagnosisPopup,
  type SkillDiagnosisHost
} from '@/composables/aptitude/useSkillDiagnosisPopup'

const instance = getCurrentInstance()
const host = computed(() => {
  const p = instance?.proxy as SkillDiagnosisHost | undefined
  return p || null
})

const {
  store,
  state,
  canDiagnose,
  insufficientMessage,
  result,
  errorMessage,
  hasResumeData,
  needsJobHistory,
  hidePopupFor10Days,
  showSkipOption,
  isYagiPrime,
  zoneDisplayName,
  closePopup,
  setVisible,
  runDiagnosis,
  resetToReady,
  openPaymentDialog
} = useSkillDiagnosisPopup(host)
</script>

<style
  lang="scss"
  src="@/assets/scss/aptitude/skill-diagnosis-popup.scss"
></style>
